import groq from 'groq'

export const newsSectionQuery = (locale: string) => groq`
  *[_type == "newsSection"][0] {
    "title": title.${locale},
    "description": description.${locale},
    "newsItems": newsItems[] {
      _id,
      "description": description.${locale},
      coverImage {
        asset->{
          _id,
          url,
          metadata {
            dimensions {
              width,
              height
            }
          }
        },
        alt
      },
      order
    } | order(order asc)
  }
`
